export const ThemeKey = Symbol('Theme')

export const useTheme = () =>
  inject<Ref<string>>(ThemeKey, ref('aplus')) // fallback
